import { debounce } from 'throttle-debounce';

export const APP_LAYOUT_CONTENT_SELECTOR = '.AppLayout__content';

// wait to display the error in the inputs before scroll
export const scrollToError = debounce(200, () => {
  const input = document.querySelector('p.Mui-error');
  return input?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
});

/**
 * The purpose of this helper is to ease scrolling to the closest parent
 * element that has AppLayout__content class (common layout component).
 *
 * Depending on the case, it could be better to store the nearest scrollable page
 * and pass it down by ref. Detection by CSS classes is not ideal in reactive apps.
 */
export const scrollToTheClosestAppLayoutContentTop = debounce(
  100,
  (ele?: HTMLElement | null) => {
    if (!ele) {
      return;
    }
    const appLayoutContent = ele.closest(APP_LAYOUT_CONTENT_SELECTOR);
    return appLayoutContent?.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }
);
